import { SET_ALERT, REMOVE_ALERT } from '../constants/alertConstants';

// Initial state for alerts
const initialState = [];

// Reducer to handle setting an alert
export const setAlertReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALERT:
      return [...state, action.payload];
    default:
      return state;
  }
};

// Reducer to handle removing an alert
export const removeAlertReducer = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_ALERT:
      return state.filter((alert) => alert.id !== action.payload);
    default:
      return state;
  }
};